import {createSelector} from "@reduxjs/toolkit";

const baseState = state => state.threads.single;

export const singleThreadSelector = createSelector([baseState], (state) => state.thread);